
import TElogo from "../../../../assets/images/dod_logo.png";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import deskImg from "../../../../assets/images/DodUserLoginpannel/Desk iMAGE png.png";
import OTPInput from "react-otp-input";
import { Toaster } from "../../../components/Toaster/Toster";
import { UserVerifyUserOtpApi } from "../../../../services/apis/AuthService";
import { ToastContainer } from "react-toastify";
import BtnLoader from "../../../components/Loader/btnLoader";

const UserForgotPasswordVerifyOtp=(props)=>{
  const location = useLocation()?.state;
  let errorsObj = { otp: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState();
  const [submitted, setSubmitted] = useState(false);
  // JSON.stringify(location?.otp)
  const [otp, setOtp] = useState("");
  const [btnLoader,setBtnLoading]=useState(false);

  const navigate = useNavigate();

  const validateFields = () => {
      const errorObj = { email: "", password: "" };
      let isError = false;
      if (!otp) {
          errorObj.otp = 'OTP is required';
          isError = true;
        } else if (!/^\d{6}$/.test(otp)) {
          errorObj.otp = 'OTP must be a 6-digit number';
          isError = true;
        }

      setErrors(errorObj);
      return isError;
    };
    
      const onLogin = async(e)=> {
        e.preventDefault();
        setSubmitted(true);
        // Validate fields
        if (validateFields()) {
          return;
        }
        setBtnLoading(true);
        const formData={
          email:location?.email ? location?.email :"",
          otp:otp
        }
        
        try {
          const res = await UserVerifyUserOtpApi(formData);
           console.log("resss",res)
           const resData = res?.data
           const stateData={
            email:location?.email,
           }

          if (resData?.success) {
            navigate("/user-change-password", {state:stateData});
          }
        } catch (error) {
          console.log("errrrr",error)
          Toaster.error(error.response?.data?.message);
        } finally {
          setBtnLoading(false);
        }
      }

    return(<>
    <ToastContainer/>
     <div className="container-xl">
         <div className="user-login-video-section">
            <div className="overlay-section"></div>
         </div>

         <div className="main-content-box row">
            <div className="col-md-6 d-flex flex-column align-items-center align-items-lg-start user-login-left-section">
              <img className="user-login-logo" src={TElogo} alt="logo"/>
              <img className="user-login-deskimg d-none d-sm-block" src={deskImg} alt="logo2"/>
              {/* <h1 className="text-white fw-bold">Forgot password</h1>
              <p className="text-white">Enter your email address and your password will be reset and emailed to you.</p> */}
              <hr className="bottom-line"/>
          </div>

            <div className="col-md-6 user-login-right-section">
               <div className="user-login-section">
                <div className="mb-3">
                 <h1 className="user-login-text mb-0">Verify Otp</h1>
                 <p className="mb-4 fs-5 text-dark">Please confirm your account by entering the authorization code
                 send to <b>{location?.email}</b> it will expire in <b>6 minutes</b>.</p>
               </div>
                <form onSubmit={onLogin}>
                <div className="mb-3">
                      <label className="mb-1 text-dark">
                        {/* <strong>OTP</strong> */}
                      </label>
                      <OTPInput
                        containerStyle={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          maxWidth: '400px',
                          margin: '0 auto',
                        }}
                        inputStyle="otp-input-style"
                        inputType="number"
                        value={otp}
                        onChange={setOtp}
                        numInputs={6}
                        renderSeparator={<span className="text-white">-</span>}
                        renderInput={(props) => <input {...props} />}
                      />
                      {errors.otp && (
                        <div className="text-danger fs-12 mt-2">
                          {errors.otp}
                        </div>
                      )}
                    </div>
                
                      <div className="">
                        <button
                          type="submit"
                          className="btn text-white btn-block user-login-btn">
                          {btnLoader && <BtnLoader/>} Verify
                        </button>

                       <button
                         type="submit"
                         className="btn text-white mt-3 px-3"
                         onClick={()=>navigate('/user/login')}>
                          <FaArrowLeft/> Go back
                       </button>
                      </div>
                    </form>
               </div>
            </div>
         </div>
     </div>
    </>)
};

export default UserForgotPasswordVerifyOtp;